// extracted by mini-css-extract-plugin
export default {"solution-picker-module":"solution-picker-module--VPt8l","solutionPickerModule":"solution-picker-module--VPt8l"};